import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { IComplianceAnalysis } from '@getgreenline/homi-shared'
import { Routes } from '../../../../constants/Routes'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'

interface Props {
  productList: IComplianceAnalysis[] | null
  onClose: () => void
  currentCompanyStore?: CurrentCompanyStore
}

export const ProductListModal = React.memo((props: Props) => {
  const { productList, onClose, currentCompanyStore } = props
  const company = currentCompanyStore!.company!

  return (
    <Modal isOpen={true} toggle={() => onClose()}>
      <ModalHeader toggle={() => onClose()}>Products</ModalHeader>
      <ModalBody>
        {productList &&
          productList.map((product) => {
            const cannaBisWeightLabel = product.productCannabisWeight
              ? `${product.productCannabisWeight} gram${
                  product.productCannabisWeight > 1 ? 's' : ''
                }`
              : 'No cannabis weight'

            return (
              <div className='mb-2' key={product.id}>
                <div className={`${product.sku ? 'text-muted' : 'text-danger'}`}>
                  {product.sku || 'NO SKU'}{' '}
                </div>
                <div className={`${product.productCannabisWeight ? 'text-muted' : 'text-danger'}`}>
                  Cannabis weight: {cannaBisWeightLabel}
                </div>
                <div>
                  <span
                    className='cursor-pointer  btn-link'
                    onClick={(e) => {
                      const selection = document.getSelection()
                      if (selection && selection.type !== 'Range') {
                        window.open(
                          `${Routes.EDIT_PRODUCT(
                            company.id,
                            product.parentProductId || product.id,
                            window.location.search,
                          )}`,
                          '_blank',
                        )
                      }
                    }}
                  >
                    {product.name}
                  </span>
                </div>
              </div>
            )
          })}
      </ModalBody>
    </Modal>
  )
})
